// The header and quote apps are separate webpack entries, each with its own runtime, so
// each one builds its own store instance from apps/shared/vuex/store.js. A currency
// picked in one store has to reach the others, or e.g. the header's selector changes
// currency without the quote app's store ever refetching its prices.
//
// This is the only bridge for that: setCurrencyState broadcasts once the change is
// committed, and every store registered with this plugin applies it via
// applyCurrencyChange - which commits and refetches, but deliberately skips
// setCurrencyState's one-off side effects (localStorage write, booking currency POST)
// so they still only happen once, in the store where the change originated.
//
// A window event rather than window.bus: the header bundle loads before the quote
// bundle, so its store can't rely on window.bus existing yet - and creating it here
// would replace the Bus instance the quote app assigns to it.
const CURRENCY_CHANGED_EVENT = 'greenmotion:store-currency-changed';

export function broadcastCurrencyChange(currency) {
    if (typeof window === 'undefined' || typeof window.dispatchEvent !== 'function') {
        return;
    }

    window.dispatchEvent(new CustomEvent(CURRENCY_CHANGED_EVENT, { detail: { ...currency } }));
}

export function currencySyncPlugin(store) {
    if (typeof window === 'undefined' || typeof window.addEventListener !== 'function') {
        return;
    }

    window.addEventListener(CURRENCY_CHANGED_EVENT, (event) => {
        // The originating store receives its own broadcast too - applyCurrencyChange
        // no-ops on the currency it already holds.
        store.dispatch('applyCurrencyChange', event.detail).catch((error) => {
            store.dispatch('createError', error);
        });
    });
}
